"use client";

import React from 'react';
import styles from './ClassificationDisplay.module.css';

const ClassificationDisplay = ({ content }) => {
  // Check for parent categories using both camelCase and snake_case.
  const parentCategories =
    (content.classification && (content.classification.parentCategories || content.classification.parent_categories)) ||
    content.parentCategories ||
    content.parent_categories ||
    [];
    
  const parentContentItems =
    (content.classification && (content.classification.parentContentItems || content.classification.parent_content_items)) ||
    content.parentContentItems ||
    content.parent_content_items ||
    [];
    
  const contentType =
    (content.classification && (content.classification.contentType || content.classification.content_type)) ||
    content.contentType ||
    content.content_type ||
    { value: 'Move' };

  return (
    <div className={styles.classificationDisplay}>
      <h1>Classification</h1>
      
      <div className={styles.section}>
        <h2>Content Type</h2>
        <p>{contentType.value}</p>
      </div>

      {parentCategories.length > 0 && (
        <div className={styles.section}>
          <h2>Parent Categories</h2>
          <ul>
            {parentCategories.map((cat, index) => (
              <li key={index}>{cat.value || cat}</li>
            ))}
          </ul>
        </div>
      )}

      {parentContentItems.length > 0 && (
        <div className={styles.section}>
          <h2>Parent Content Items</h2>
          <ul>
            {parentContentItems.map((item, index) => (
              <li key={index}>{item.value || item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ClassificationDisplay;
